// Manager approval modal shows specific massage per legacy POS.

export const getErrorMessage = (errorMessageCode?: string): string => {
  switch (errorMessageCode) {
    case 'IdmInvalidUserNamePasswordLoginProvided':
      return (
        'ManagerApproval_WrongAuthentication' ||
        'Invalid User ID or Pin Code. If problem persists, please contact Administrator'
      );
    case 'IdmUserBlocked':
      return 'ManagerApproval_BlockedUser' || 'User Blocked';
    case 'IdmUserLockedException':
      return 'ManagerApproval_FailedIdentification_UserLocked' || 'User Locked';
    case 'IdmUserDisabledException':
      return 'ManagerApproval_FailedIdentification_UserDisabled' || 'User Disabled';
    default:
      return errorMessageCode || '';
  }
};
